// วันที่ท้องถิ่นแบบ YYYY-MM-DD (client เป็นคนบอกวันของตัวเอง — เลี่ยงปัญหา timezone ฝั่ง worker)
export function todayStr() {
  return new Date().toLocaleDateString('en-CA'); // en-CA = YYYY-MM-DD
}

export function fmtDate(iso) {
  try {
    return new Date(iso + 'T00:00:00').toLocaleDateString('th-TH', {
      day: 'numeric', month: 'short',
    });
  } catch { return iso; }
}

export function fmtNum(n) {
  return Number(n || 0).toLocaleString('th-TH');
}

// ก้าว → กม. (steps_per_km จาก config)
export function toKm(steps, stepsPerKm) {
  return (Number(steps || 0) / (stepsPerKm || 1300)).toFixed(1);
}
